import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { Globals } from '../../shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserData } from '../../shared/models/DTO/UserData';
import { GenericVm } from '../../shared/models/system/generic-vm';
import { Message } from '../../shared/models/system/message';
import { MessageEnum } from '../../shared/models/system/message.enum';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class StudentService extends UserService {

  constructor(private http: HttpRequestService, private global: Globals, private trans: TranslateService) {
    super(http, global, trans);
  }

  getStudentByCarcteria(name, courseCode, crnCode, upage, upagesize)
  {
  //  alert(courseCode);
  return  this.http.GetRequest('user/Students/' + name + '/' + crnCode + '/' + courseCode + '/' + upage + '/' + upagesize).toPromise();
  }

  getStudentDetail(studentId: string)
  {
  return  this.http.GetRequest('user/studentdetail/' + studentId);
  }

  getCRNStudent(crnCode: string)
  {
  return  this.http.GetRequest('user/CRNstudent/' + crnCode);
  }
}
